import './applicantPage.scss';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import heroWithCamera from '../../../assets/hero-with-camera.svg';
import { Header } from '../../../components/Header/Header';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import useWorkflowStore from '../../../store/workflowStore/useWorkflowStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { next } = useWorkflowStore();
  const { handleSubmit } = useForm();

  const {
    computed: { vehicleYearMakeModel },
  } = useDashboardStore();

  const formSubmit = (): void => {
    navigate(next());
  };

  return (
    <ThemeProvider theme={theme}>
      <Box className="applicant-page" sx={theme.pageLayout}>
        <Header
          progress={useWorkflowStore.getState().computed.progress}
          showDrawerToggle
          showLogo
        />

        <main>
          <figure>
            <img alt={t('imageAlts.heroWithCamera')} src={heroWithCamera} />
          </figure>
          <form
            data-testid={locator.pages.applicant.form.root}
            noValidate
            onSubmit={handleSubmit(formSubmit)}
          >
            <div className="form-content">
              <h1 data-testid={locator.pages.applicant.form.h1}>
                {t('ApplicantPage.title', {
                  vehicle: vehicleYearMakeModel,
                })}
              </h1>
              <h2 data-testid={locator.pages.applicant.form.h2}>
                {t('ApplicantPage.subtitle')}
              </h2>

              <div style={{ marginBottom: '3rem' }}>
                <Button
                  color="primary"
                  data-testid={locator.pages.applicant.form.submitButton}
                  startIcon={<></>}
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  {t('ApplicantPage.continue')}
                </Button>
              </div>
            </div>
            <footer data-testid={locator.pages.applicant.footer.root}>
              {t('copyright', { year: new Date().getFullYear() })}
            </footer>
          </form>
        </main>
      </Box>

      <NavigationPane withDrawer withUserNameHeader />
    </ThemeProvider>
  );
}

Component.displayName = 'ApplicantPage';
